import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { TranslocoModule } from '@jsverse/transloco';
import { ButtonDirective, DialogModule, DialogRef, FormFieldComponent, LabelDirective, SelectImports } from 'shared/ui-common';

import { DIALOG_DATA, FlowchartElementType } from '@treetop/shared/model';

@Component({
  selector: 'app-proposed-component-chooser-dialog',
  templateUrl: './proposed-component-chooser-dialog.component.html',
  styleUrls: ['./proposed-component-chooser-dialog.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    TranslocoModule,
    MatSelectModule,
    MatFormFieldModule,
    MatOptionModule,

    DialogModule,
    MatIconModule,
    SelectImports,
    FormFieldComponent,
    LabelDirective,
    ButtonDirective,
  ],
})
export class ProposedComponentChooserDialogComponent implements OnInit {
  public data = inject(DIALOG_DATA);
  private dialogRef: DialogRef = inject(DialogRef);

  proposedType;
  flowchartElementType = FlowchartElementType;

  ngOnInit() {
    this.proposedType = FlowchartElementType.FlowchartAction;
  }

  closeDialog() {
    this.dialogRef.close(this.proposedType);
  }

  closeDialogWithoutSelection() {
    this.dialogRef.close(null);
  }
}
